var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisualArrowsWithgreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.474,
    height: 985.057,
    viewBox: "0 0 214.474 985.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visual-arrows-withgreen",
    transform: "translate(-961.606 -89.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3024",
    "data-name": "Path 3024",
    d: "M2961.538,23,2794.352,512.075l112.654,286.967h98.819l-44.288-280.955L3005.825,23Z",
    transform: "translate(-1829.746 66.987)",
    fill: "#15abc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M-4779.864-23.773h34.09L-4881.484,466.7l135.71,494.584h-34.09L-4928.27,466.7Z",
    transform: "translate(5889.876 113.76)",
    fill: "#f37021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2973",
    "data-name": "Path 2973",
    d: "M-4778.1-23.773h34.5L-4893.727,466.7-4743.6,961.284h-34.5L-4928.27,466.7Z",
    transform: "translate(5919.679 113.76)",
    fill: "#c34628",
    opacity: 0.248
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualArrowsWithgreen);
export default __webpack_public_path__ + "static/media/visual-arrows-withgreen.bcc2edfef2085d914019370266f876c9.svg";
export { ForwardRef as ReactComponent };